import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

const Error = ({reason, reasonParams}) => {
    reasonParams = reasonParams || [];

    return (
        <span className="input-error-message">
            {messages.error.validation[reason] ?
                <FormattedMessage {...messages.error.validation[reason]} values={Object.assign({}, ...reasonParams)} /> : reason}
        </span>
    );
};

export default Error;
